import { Roles } from "./organize";
/**
 * Check if user is one of the target role.
 * @param {array} roles
 * @param {string} target 
 */
function isRole(roles ,target){
	return roles.findIndex((v)=>v.toLowerCase()===target.toLowerCase()) !== -1;
}
export default { Roles, isRole };


// WEBPACK FOOTER //
// ./src/util/user.js